"use client";
import { Prisma } from "@prisma/client";
import { useMemo } from "react";
import { If } from "~/components/v3/Conditional";
import { sponsorPlanColors, SponsorTierCard } from "./SponsorTierCard";

interface SponsorTierSelectorProps {
    sponsorshipPackage: Prisma.SponsorshipPackageGetPayload<{
        include: { packageTiers: true };
    }>;
    communitySlug: string;
    showTitle?: boolean;
    selectedTier: any;
    onTierSelect: (tier: any) => void;
}

const SponsorTierSelector = ({
    sponsorshipPackage,
    communitySlug,
    showTitle = true,
    selectedTier,
    onTierSelect,
}: SponsorTierSelectorProps) => {
    const sortedTiers = useMemo(() => {
        return [...(sponsorshipPackage?.packageTiers ?? [])].sort((a, b) => {
            return (
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime()
            );
        });
    }, [sponsorshipPackage?.packageTiers]);

    const handleSelectTier = (tier: any) => {
        onTierSelect(selectedTier?.id === tier.id ? null : tier);
    };

    return (
        <div className="w-full">
            <If condition={showTitle}>
                <h4 className="mb-4 text-lg font-bold">
                    Available Sponsorship Tiers
                </h4>
            </If>
            {sponsorshipPackage && (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {sortedTiers.map((tier, index) => (
                        <SponsorTierCard
                            key={tier.id}
                            tier={tier}
                            asset={sponsorshipPackage.asset}
                            communitySlug={communitySlug}
                            color={
                                sponsorPlanColors[
                                    index % sponsorPlanColors.length
                                ] ?? "black"
                            }
                            isSelected={selectedTier?.id === tier.id}
                            onSelect={() => handleSelectTier(tier)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SponsorTierSelector;
